import React from 'react';
import {
  Box,
  Modal,
  Card,
  CardContent,
  Button,
  Portal,
  Typography,
  ToggleButton,
  ToggleButtonGroup
} from '@mui/material';
import { useSaleCalendar } from '../SaleCalendarContext';
import { eachDayOfInterval } from 'date-fns';
import { useSelector } from 'react-redux';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

const DAYS = [
  { label: 'Pn', value: 'monday' },
  { label: 'Wt', value: 'tuesday' },
  { label: 'Śr', value: 'wednesday' },
  { label: 'Cz', value: 'thursday' },
  { label: 'Pt', value: 'friday' },
  { label: 'Sb', value: 'saturday' },
  { label: 'Nd', value: 'sunday' }
];

const WEEKDAY_MAP = {
  saturday: 0,
  sunday: 1,
  monday: 2,
  tuesday: 3,
  wednesday: 4,
  thursday: 5,
  friday: 6
};

export default function TransitionDaysModal({ open, handleClose }) {
  const { setTransitionDayEvents, periods } = useSaleCalendar();
  const { seasonYear } = useSelector(state => state.app);
  const [days, setDays] = React.useState('all');


  const handleDayToggle = (event, newDays) => {
    if (newDays.length === 0) {
      setDays([]);
    } else {
      setDays(newDays);
    }
  };

  const handleSubmit = () => {
    const selectedDays = days === 'all' ? Object.keys(WEEKDAY_MAP) : days;

    const start = new Date(seasonYear, 0, 1);
    const end = new Date(seasonYear, 11, 31);

    const allDays = eachDayOfInterval({ start, end });

    const matchingDays = allDays.filter(date => selectedDays.includes(
      Object.keys(WEEKDAY_MAP).find(
        key => WEEKDAY_MAP[key] === date.getDay()
      )
    )
    );

    setTransitionDayEvents(prev => {
      const existingIds = new Set(prev.map(item => item.id));
      const newItems = [];

      for (const day of matchingDays) {
        const dateStr = day.toISOString().slice(0, 10);

        for (const period of periods.filter(p => [
          '3 DNI - MUNDUROWA',
          '3 DNI GIEWARTÓW',
          '3 DNI MRÓWKI',
          '3 DNI',
          'WEEKEND',
          'WEEKEND GIEWARTÓW',
          'WEEKEND MRÓWKI',
          '5 DNI - MUNDUROWA',
          '5 DNI GIEWARTÓW',
          '5 DNI MRÓWKI',
          '5 DNI'
        ].includes(p.title))) {
          const eventId = `${dateStr}-${period.id}`;
          if (!existingIds.has(eventId)) {
            newItems.push({
              start: dateStr,
              end: dateStr,
              display: 'background',
              color: 'transparent',
              classNames: ['transition-day-zebra'],
              id: eventId,
              resourceId: period.id,
              type: 'transitionDay'
            });
          }
        }
      }

      return newItems;
    });

    handleClose();
  };


  return (
    <Portal>
      <Modal open={open} onClose={handleClose} id="block-modal">
        <Card sx={{ ...style, width: '500px' }}>
          <CardContent>
            <Typography variant="body1" textAlign="center">
              Ustaw dni przejściowe w całym roku
            </Typography>
            <Box height={20} />
            <>
              <Box height={20} />
              <Typography variant="body2">Wybierz dni:</Typography>
              <ToggleButtonGroup
                value={days === 'all' ? DAYS.map(d => d.value) : days}
                onChange={handleDayToggle}
                size="small"
                fullWidth
                color="primary"
              >
                {DAYS.map(day => (
                  <ToggleButton key={day.value} value={day.value}>
                    {day.label}
                  </ToggleButton>
                ))}
              </ToggleButtonGroup>
              <Box height={10} />
              <Button
                size="small"
                onClick={() => setDays(
                  days === 'all' || days.length === DAYS.length
                    ? []
                    : DAYS.map(d => d.value)
                )
                }
              >
                {days.length === DAYS.length ? 'Odznacz wszystko' : 'Zaznacz wszystkie'}
              </Button>
            </>
            <Box height={20} />
            <Button variant="contained" onClick={handleSubmit}>
              Ustaw
            </Button>
          </CardContent>
        </Card>
      </Modal>
    </Portal>
  );
}
